import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

type SireSaveWarningDialogProps = {
  open: boolean;
  mode: 'new' | 'edit';
  onConfirm: () => void;
  onCancel: () => void;
};

export const SireSaveWarningDialog = ({
  open,
  mode,
  onConfirm,
  onCancel,
}: SireSaveWarningDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent
        className="z-[2100] md:max-w-md"
        overlayClassName="z-[2100]"
      >
        <DialogHeader>
          <DialogTitle>{t('sire.saveWarningHeader')}</DialogTitle>
          <DialogDescription>
            {mode === 'new'
              ? t('sire.saveWarningNew')
              : t('sire.saveWarningEdit')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button type="button" onClick={onConfirm}>
            {t('common.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
